(() => {
  let pendingForm = null;
  let confirmedForm = null;
  let newsletterTimer = null;
  let newsletterShown = false;
  const preferenceKey = 'potency_newsletter_v1';
  const readPreference = () => {
    try { return JSON.parse(localStorage.getItem(preferenceKey) || '{}'); } catch { return {}; }
  };
  const savePreference = value => {
    try { localStorage.setItem(preferenceKey, JSON.stringify(value)); } catch {}
  };
  const closeNewsletter = () => {
    const newsletter = document.querySelector('[data-newsletter-popup]');
    if (newsletter?.open) newsletter.close();
  };
  const openNewsletter = force => {
    const dialog = document.querySelector('[data-newsletter-popup]');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    const preference = readPreference();
    if (!force && (newsletterShown || dialog.dataset.subscribed === 'true' || preference.subscribed || Number(preference.dismissedUntil) > Date.now())) return;
    if (document.hidden || document.querySelector('dialog[open]')) {
      if (!force) newsletterTimer = setTimeout(() => openNewsletter(false), 3000);
      return;
    }
    dialog.showModal();
    newsletterShown = true;
  };
  const templateFor = form => [...document.querySelectorAll('[data-purchase-options]')].find(t => t.dataset.purchaseOptions === form.elements.id.value);
  const openSubscription = form => {
    const dialog = document.querySelector('[data-subscription-popup]');
    const template = templateFor(form);
    if (!dialog || !template || typeof dialog.showModal !== 'function') return false;
    closeNewsletter();
    clearTimeout(newsletterTimer);
    newsletterShown = true;
    dialog.querySelector('[data-plan-choices]').replaceChildren(template.content.cloneNode(true));
    dialog.querySelector('[data-popup-quantity]').textContent = form.elements.quantity.value;
    const error = dialog.querySelector('[data-subscription-error]');
    error.hidden = true;
    error.textContent = '';
    dialog.querySelector('[data-recurring-note]').hidden = true;
    pendingForm = form;
    if (!dialog.open) dialog.showModal();
    return true;
  };
  window.PotencyPopups = {
    offerSubscription(form) {
return false;
      if (confirmedForm === form) { confirmedForm = null; return false; }
      const input = form.querySelector('[data-selling-plan-input]');
      if (input) { input.disabled = true; input.value = ''; }
      const template = templateFor(form);
      if (!template) return false;
      const hasPlans = Number(template.dataset.planCount) > 0;
      const isPreview = template.dataset.previewEnabled === 'true';
      if (hasPlans || isPreview || template.dataset.required === 'true') return openSubscription(form);
      return false;
    }
  };
  function init(root = document) {
    root.querySelectorAll('.potency-popup').forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (dialog.matches('[data-newsletter-popup]')) {
          const preference = readPreference();
          savePreference({ ...preference, dismissedUntil: Date.now() + Number(dialog.dataset.dismissDays || 7) * 86400000 });
        }
        if (dialog.matches('[data-subscription-popup]')) pendingForm = null;
      });
    });
    root.querySelectorAll('[data-newsletter-open]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => openNewsletter(true));
    });
    root.querySelectorAll('[data-subscription-preview]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const form = document.getElementById('ProductForm');
        if (form) openSubscription(form);
      });
    });
    const newsletter = document.querySelector('[data-newsletter-popup]');
    const newsletterForm = newsletter?.querySelector('#PotencyNewsletter');
    if (newsletterForm && !newsletterForm.dataset.consentBound) {
      newsletterForm.dataset.consentBound = 'true';
      newsletterForm.addEventListener('submit', event => {
        const consentPanel = newsletterForm.querySelector('[data-newsletter-consent]');
        const consent = newsletterForm.querySelector('#NewsletterConsent');
        if (consentPanel?.hidden) {
          event.preventDefault();
          consentPanel.hidden = false;
          consent.disabled = false;
          const submit = newsletterForm.querySelector('[data-newsletter-submit]');
          submit.textContent = submit.dataset.confirmLabel;
          consent.focus();
        }
      });
    }
    if (newsletter && !newsletter.dataset.scheduled) {
      newsletter.dataset.scheduled = 'true';
      const result = newsletter.querySelector('[data-newsletter-result]');
      if (result?.dataset.newsletterResult === 'success') savePreference({ subscribed: true });
      if (result) openNewsletter(true);
      else if (newsletter.dataset.auto === 'true') newsletterTimer = setTimeout(() => openNewsletter(false), Number(newsletter.dataset.delay || 6000));
    }
    const choice = document.getElementById('SubscriptionChoice');
    if (choice && !choice.dataset.bound) {
      choice.dataset.bound = 'true';
      choice.addEventListener('change', () => {
        const selected = choice.querySelector('[name=purchase_plan]:checked');
        choice.querySelector('[data-recurring-note]').hidden = !selected?.value || selected.hasAttribute('data-preview-plan');
        choice.querySelector('[data-subscription-error]').hidden = true;
      });
      choice.addEventListener('submit', event => {
        event.preventDefault();
        const selected = choice.querySelector('[name=purchase_plan]:checked');
        if (!selected || !pendingForm) return;
        const error = choice.querySelector('[data-subscription-error]');
        if (selected.hasAttribute('data-preview-plan')) {
          error.textContent = choice.dataset.previewMessage;
          error.hidden = false;
          return;
        }
        const form = pendingForm;
        if (!form.reportValidity()) return;
        const input = form.querySelector('[data-selling-plan-input]');
        input.value = selected.value;
        input.disabled = selected.value === '';
        confirmedForm = form;
        choice.closest('dialog').close();
        form.requestSubmit();
      });
    }
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => { clearTimeout(newsletterTimer); pendingForm = null; confirmedForm = null; });
  init();
})();
